import React from 'react';
import {NextMonthIcon, PreviousMonthIcon} from "./Icons";
import {VISIBLE_DAYS} from "../hooks/useTimeRecords";
import {IconButton} from "./IconButton";
import Typography from "./Typography";

type DateRangeNavigatorProps = {
    windowDates: Date[];
    onPrevious: () => void;
    onNext: () => void;
    canGoNext?: boolean;
};

export const DateRangeNavigator: React.FC<DateRangeNavigatorProps> = ({
                                                                          windowDates,
                                                                          onPrevious,
                                                                          onNext,
                                                                          canGoNext = true,
                                                                      }) => {

    return (
        <div style={{display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'space-between'}}>
            <IconButton
                size="small"
                variant="outlined"
                onClick={onPrevious}
                aria-label="Ältere Einträge"
            >
                <PreviousMonthIcon/>
            </IconButton>

            <Typography variant="caption" color="secondary" align="center">
                {windowDates[0]
                    ? windowDates[0].toLocaleDateString('de-DE', {
                        day: 'numeric',
                        month: 'short',
                    })
                    : ''}
                {' – '}
                {windowDates[VISIBLE_DAYS - 1]
                    ? windowDates[VISIBLE_DAYS - 1].toLocaleDateString('de-DE', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                    })
                    : ''}
            </Typography>

            <IconButton
                size="small"
                variant="outlined"
                onClick={onNext}
                isDisabled={!canGoNext}
                aria-label="Neuere Einträge"
            >
                <NextMonthIcon/>
            </IconButton>
        </div>
    );
};